import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import RichText from '../../molecules/richtext';
import { media } from '../../../utils/media-queries';

const PullQuote = ({ quote, author }) => {
  const { ref, inView, entry } = useInView({ threshold: 0.1 });

  return (
    <StyledPullQuote
      ref={ref}
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : -50 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
    >
      <div>
        <motion.p
          className="bold-big text-gradient"
          initial={{
            backgroundSize: '100%',
          }}
          animate={{
            backgroundSize: inView ? '10000%' : '100%',
          }}
          transition={{ duration: 4 }}
        >
          {quote}
        </motion.p>
        <div className="author">
          <RichText blocks={author} />
        </div>
      </div>
    </StyledPullQuote>
  );
};

const StyledPullQuote = styled(motion.section)`
  padding-top: var(--v-spacing-L);
  padding-bottom: calc(var(--v-spacing-L) * 2);
  margin: 0;

  .bold-big {
    text-align: center;
    padding-bottom: var(--spacing-S);
    color: var(--red);
    background-image: linear-gradient(
      178deg,
      rgba(8, 30, 112) 0%,
      rgba(27, 81, 127) 30%,
      rgba(255, 56, 42) 70%,
      rgba(255, 56, 42) 100%
    );
    background-position: bottom right;
    margin: 0 auto;
  }

  .author {
    text-align: center;
    font-size: var(--font-size-0);
    color: var(--blue);
  }

  @media ${media.L} {
    margin: 0 calc(var(--v-spacing-L) * 2);

    .bold-big {
      max-width: 85%;
    }
  }
`;

PullQuote.propTypes = {
  quote: PropTypes.string,
  author: PropTypes.array,
};

export default PullQuote;
